<script lang="ts" setup generic="T">
import { computed } from 'vue'
import { forceColorShade } from '~/utils/colors'

const props = defineProps<{
  item?: T
  color: string
  element?: string
  hoverEffect?: boolean
  paddedStack?: boolean
}>()

const baseColor = computed(() => props.color || '--color-white')
const shadowColor1 = computed(() => forceColorShade(baseColor.value, '20'))
const shadowColor2 = computed(() => forceColorShade(baseColor.value, '50'))
const tag = computed(() => props.element || 'div')
</script>

<template>
  <component :is="tag" class="group">
    <div
      class="h-full"
      :style="paddedStack
        ? {
          paddingInlineEnd: `8px`,
          paddingBlockEnd: `8px`,
        }
        : {}
      "
    >
      <div class="relative h-full">
        <div
          class="absolute inset-0 rounded-lg"
          style="padding-inline-start: 8px"
          :style="[
            'transform: translate(8px, 8px);',
            `background: ${shadowColor2};`,
          ]"
        />
        <div
          class="absolute inset-0 rounded-lg"
          style="padding-inline: 8px"
          :style="[
            'transform: translate(4px, 4px);',
            `background: ${shadowColor1};`,
          ]"
        />
        <div
          class="relative grid min-h-full rounded-lg bg-(--background) text-black transition hover:bg-(--hover-color)"
          :style="`--background: ${baseColor}; --hover-color: rgb(from ${baseColor} r g b / .90);`"
        >
          <slot :item="item" />
        </div>
      </div>
    </div>
  </component>
</template>
